import pageTitle from 'ember-page-title/helpers/page-title';
import { t } from 'ember-intl';

<template>
  {{pageTitle (t "results")}}
  {{outlet}}
</template>
